// extracted by mini-css-extract-plugin
export default {"card":"profileSlider_card__SYbev","imageSlider":"profileSlider_imageSlider__F2ZQE","title":"profileSlider_title__pw1f5"};